module.exports = __webpack_public_path__ + "img/p12.eb56d1b4.png";